"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9298],{

/***/ 87207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Leaflet; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/generic.js + 6 modules
var generic = __webpack_require__(66001);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/element.js
var lib_element = __webpack_require__(27999);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/context.js
var context = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(45243);
var leaflet_src_default = /*#__PURE__*/__webpack_require__.n(leaflet_src);
;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/Polygon.js


const Polygon = (0,generic/* createPathComponent */.Au)(function createPolygon({ positions , ...options }, ctx) {
    const polygon = new leaflet_src.Polygon(positions, options);
    return (0,lib_element/* createElementObject */.O)(polygon, (0,context/* extendContext */.sj)(ctx, {
        overlayContainer: polygon
    }));
}, function updatePolygon(layer, props, prevProps) {
    if (props.positions !== prevProps.positions) {
        layer.setLatLngs(props.positions);
    }
});

// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/Marker.js
var Marker = __webpack_require__(20577);
// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/MapContainer.js
var MapContainer = __webpack_require__(5715);
// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/TileLayer.js + 1 modules
var TileLayer = __webpack_require__(52013);
// EXTERNAL MODULE: ./node_modules/react-leaflet/lib/AttributionControl.js
var AttributionControl = __webpack_require__(29310);
// EXTERNAL MODULE: ./src/helpers/maps/getLeafletProvider.ts
var getLeafletProvider = __webpack_require__(25196);
// EXTERNAL MODULE: ./src/helpers/misc/getFileURL.ts
var getFileURL = __webpack_require__(2381);
// EXTERNAL MODULE: ./node_modules/leaflet-gesture-handling/dist/leaflet-gesture-handling.min.js
var leaflet_gesture_handling_min = __webpack_require__(25830);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet.css
var leaflet = __webpack_require__(13136);
// EXTERNAL MODULE: ./node_modules/leaflet-gesture-handling/dist/leaflet-gesture-handling.css
var leaflet_gesture_handling = __webpack_require__(71612);
;// CONCATENATED MODULE: ./src/components/componentTypes/DeliveryZone/Leaflet/Map.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









leaflet_src_default().Map.addInitHook("addHandler", "gestureHandling", leaflet_gesture_handling_min.GestureHandling);
function Leaflet(param) {
    var iconURL = param.iconURL, color = param.color, center = param.center, getStores = param.getStores, getPoints = param.getPoints;
    var renderAreas = function() {
        var options = {
            weight: 1,
            fillOpacity: 0.2,
            fillColor: color,
            color: color
        };
        return getStores().map(function(store) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: store.zones.map(function(zone) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Polygon, {
                        positions: zone.deliveryLimits,
                        pathOptions: options
                    }, "polygon_".concat(zone._id));
                })
            }, "store_".concat(store._id));
        });
    };
    var renderStores = function() {
        return getStores().map(function(store) {
            var iconSize = 25;
            var icon = new (leaflet_src_default()).Icon({
                iconUrl: iconURL ? (0,getFileURL/* default */.Z)(iconURL) : "/images/store-in-map.svg",
                iconSize: [
                    iconSize,
                    iconSize
                ],
                iconAnchor: [
                    iconSize / 2,
                    iconSize / 2
                ]
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker/* Marker */.J, {
                icon: icon,
                position: store.address.location
            }, "marker_".concat(store._id));
        });
    };
    var setCenter = function(map) {
        if (!map) return;
        var points = getPoints();
        var bounds = new (leaflet_src_default()).LatLngBounds(null);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var point = _step.value;
                bounds.extend(point);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        map.fitBounds(bounds);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapContainer/* MapContainer */.h, {
        center: [
            center.lat,
            center.lng
        ],
        zoom: 15,
        scrollWheelZoom: false,
        ref: setCenter,
        // 👇️ Estos 2 comentarios permiten ignorar que gestureHandling no es una opción nativa de MapContainer (añadida por leaflet-gesture-handling)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        gestureHandling: true,
        attributionControl: false,
        style: {
            width: "100%",
            height: "400px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayer/* TileLayer */.I, _objectSpread({}, (0,getLeafletProvider/* default */.Z)())),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributionControl/* AttributionControl */.z, {
                prefix: false
            }),
            renderAreas(),
            renderStores()
        ]
    });
};


/***/ }),

/***/ 25196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLeaftletProvider; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_domain_getCurrentMainDomain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55879);
/* harmony import */ var _providers_getEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4266);


var MAP_TILER_WEB_COMPONENTS_TOKEN = "iUzDOAFCUx33tmT6OCea";
var providers = {
    openStreetMap: {
        attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
        minZoom: 1,
        crossOrigin: true,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    },
    mapTiler: {
        attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        crossOrigin: true,
        url: "https://api.maptiler.com/maps/streets/{z}/{x}/{y}@2x.png?key=".concat(MAP_TILER_WEB_COMPONENTS_TOKEN)
    }
};
var provider = null;
function getLeaftletProvider() {
    if (!provider) {
        if ((0,_providers_getEnv__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() === "prod" && (0,_helpers_misc_domain_getCurrentMainDomain__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() !== "bejusto.com") {
            provider = providers.mapTiler;
        } else {
            provider = providers.openStreetMap;
        }
    }
    return provider;
};


/***/ }),

/***/ 2381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GetFileURL; }
/* harmony export */ });
/**
 *
 * WARNING
 * this function will return an s3 file.
 * use a URL that goes through CloudFront (CDN) if possible.
 */ function GetFileURL(file) {
    if (!file) return;
    return "https://s3.amazonaws.com/".concat(file.bucket, "/").concat(file.key.replace(/ /g, "%20"));
};


/***/ })

}]);